<!-------品目列表-------->
<template>
  <div>
    <div v-if="!readOnly" class="flex-align__between table-btn-group">
      <div>
        <div class="upload-button info-button" @click="importItems">
          <div class="flex-align">
            <img src="@/assets/images/import.png" alt="" />
            批量导入
          </div>

          <input
            v-show="false"
            ref="fileupload"
            type="file"
            name="fileupload"
            :value="uploadFile"
            @change.stop="fileChange"
          />
        </div>

        <download-file
          class="m-l-20"
          download-link="/resources/招募品目导入模板.xlsx"
        >
          <div class="flex-center">
            <img src="@/assets/images/download.png" alt="" />
            <span>下载品目导入模板</span>
          </div>
        </download-file>
      </div>

      <el-button
        type="text"
        class="info-button"
        :disabled="!selectedList.length"
        @click="deleteBatch"
      >
        <div class="flex-align">
          <img src="@/assets/images/delete.png" alt="" />
          批量删除
        </div>
      </el-button>
    </div>

    <el-table
      ref="materialTable"
      size="medium"
      border
      highlight-current-row
      :data="pageMaterialList"
      max-height="460"
      @selection-change="changeSelection"
    >
      <el-table-column v-if="!readOnly" type="selection" width="60" />
      <el-table-column
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
      />
      <el-table-column
        label="品目名称"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielName || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="计划采购数量"
        align="right"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ strToThousands(row.materielNum || 0) || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="单位"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielUnit || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="计划采购金额(万元)"
        align="right"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ strToThousands(row.budgetTotalPrice || 0) || ' - ' }} </span>
        </template>
      </el-table-column>
      <el-table-column
        label="需求描述"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.remarks || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="160" fixed="right">
        <template slot-scope="{ row, $index }">
          <el-button
            v-if="!readOnly"
            class="primary-button"
            type="text"
            @click="editItem(row, $index)"
          >编辑</el-button>
          <el-button
            v-if="!readOnly"
            class="danger-button"
            type="text"
            @click="deleteItem($index)"
          >删除</el-button>
          <el-button
            v-if="readOnly"
            type="text"
            @click="openDetail(row)"
          >查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--      点击添加品目-->
    <div v-if="!readOnly" class="table-btn flex-center" @click="addItem()">
      <i class="el-icon-plus"></i> 添加品目
    </div>

    <!-------品目操作或查看详情弹窗------------>
    <recruit-item-operator
      ref="recruitItemOperator"
      @refresh="refreshItemList"
    />
  </div>
</template>

<script>
import RecruitItemOperator from './RecruitItemOperator'
import DownloadFile from '@/components/common/DownloadFile'
import { cloneDeep, xorWith, isEqual } from 'lodash'
import { importRecruitSupplierApi } from '@/api/supplier-management/recruit'

// 工具
import { strToThousands } from '@/utils/utils'

export default {
  components: { RecruitItemOperator, DownloadFile },

  props: {
    // 是否是详情展示，默认否
    readOnly: {
      type: Boolean,
      default: false
    },
    materielList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      strToThousands,

      itemList: [], // 品目列表
      pageMaterialList: [], // 分页显示的列表
      page: 1,
      size: 10,
      currentIndex: -1, // 当前选中的品目在列表中的排位
      selectedList: [], // 当前勾选的品目列表

      uploadFile: '' // 上传的文件
    }
  },

  computed: {
    totalPage() {
      return this.itemList.length / this.size
    }
  },

  watch: {
    materielList: {
      handler(val) {
        this.itemList = cloneDeep(val)
      },
      immediate: true
    },

    itemList: {
      handler(val) {
        this.getPageData()
      },
      immediate: true
    }
  },

  created() {
    this.listenTable()
  },

  beforeDestroy() {
    const dom = this.$refs.materialTable.bodyWrapper
    dom.removeEventListener('scroll', this.changeScrollDistance)
  },

  methods: {
    /**
     * 获取勾选列表
     */
    changeSelection(selection) {
      this.selectedList = selection
    },

    /**
     * 删除品目
     */
    deleteItem(index) {
      this.$systemConfirm('DELETE_MATERIAL').then(result => {
        if (!result) return
        this.itemList.splice(index, 1)
      })
    },

    /**
     * 批量删除
     */
    deleteBatch() {
      this.$systemConfirm('DELETE_SELECTED_MATERIAL').then(result => {
        if (!result) return
        // 两个数组取差集， 得到删除后的数组
        this.itemList = xorWith(this.selectedList, this.itemList, isEqual)
      })
    },

    /**
     * 新增品目
     */
    addItem() {
      this.currentIndex = -1
      this.$refs.recruitItemOperator.open()
    },

    /**
     * 修改品目
     */
    editItem(row, index) {
      this.currentIndex = index
      this.$refs.recruitItemOperator.open(row)
    },

    /**
     * 打开详情查看
     */
    openDetail(row) {
      this.$refs.recruitItemOperator.open(row, true)
    },

    /**
     * 批量导入品目
     */
    importItems() {
      this.$refs.fileupload.click()
    },

    /**
     * 导入文件
     */
    fileChange(e) {
      const fileList = Array.from(e.currentTarget.files)

      if (!fileList[0]) {
        return false
      }

      this.$refs.fileupload.value = ''

      importRecruitSupplierApi({ file: fileList[0] })
        .then(res => {
          const tempArray = [...res.data, ...this.itemList]
          if (tempArray.length > 200) {
            this.$message.warning('品目条数上限为200条')
            return false
          }
          this.itemList = tempArray
          this.getPageData()
        })
        .catch(err => {
          this.$message.error(err.message || '导入失败')
        })
    },

    /**
     * @description: 前端分页，获取当前页数据
     */
    getPageData() {
      this.page = Math.ceil(this.itemList.length / this.size)
      const start = (this.page - 1) * this.size
      const end = start + this.size
      this.pageMaterialList = this.itemList.slice(0, end)
      if (this.pageMaterialList.length === 0 && this.page > 1) {
        this.page = this.page - 1
        this.getPageData()
      }
    },

    /**
     * 监听列表滚动
     */
    listenTable() {
      this.$nextTick(() => {
        const dom = this.$refs.materialTable.bodyWrapper
        dom.addEventListener('scroll', this.changeScrollDistance)
      })
    },

    /**
     * 前端展示数据
     */
    changeScrollDistance() {
      const dom = this.$refs.materialTable.bodyWrapper
      const scrollDistance = dom.scrollHeight - dom.scrollTop - dom.clientHeight
      if (scrollDistance <= 0) {
        // 等于0证明已经到底，可以请求接口
        if (this.page < this.totalPage) {
          // 当前页数小于总页数就请求
          this.page++ // 当前页数自增
          // 请求接口的代码
          this.getPageData()
        }
      }
    },

    /**
     * 关闭操作品目弹窗更新列表
     */
    refreshItemList(data) {
      // 新增
      if (this.currentIndex === -1) {
        this.itemList.unshift(data)
      } else {
        // 修改
        this.$set(this.itemList, this.currentIndex, data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.table-btn-group {
  padding: 0 pixel-to-rem($n: 30);

  ::v-deep .el-button + .el-button {
    margin-left: pixel-to-rem($n: 30);
  }

  img {
    width: pixel-to-rem($n: 26);
    height: pixel-to-rem($n: 26);
    margin-right: pixel-to-rem($n: 10);
    border: none;
  }
}
.table-btn {
  height: pixel-to-rem($n: 60);
  background-color: $primary-background-color;
  color: $primary-color;
  @include text-bold;
  font-size: pixel-to-rem($n: 18);
  cursor: pointer;

  i {
    @include text-bold;
    font-size: pixel-to-rem($n: 18);
    margin-right: pixel-to-rem($n: 10);
    padding-top: 1px;
  }
}

.upload-button {
  display: inline-block;
  margin-right: pixel-to-rem($n: 20);
  cursor: pointer;
  &:hover {
    color: $primary-color;
  }
}
</style>
